import {authHeader} from "@/helpers/authservice/auth-header";
import axios from "axios";
import Swal from "sweetalert2";
import {requiredHeaders} from "@/helpers/authservice/requiredHeaders";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "./log";
import {defineStore} from "pinia";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";

export const usePackagesManagerModule = defineStore("packagesManagerModule", {


        state: () => ({
            lazyLoaderModule: useLazyLoaderModule(),
            commonModule:useCommonAppModule(),
            //Common
            backendModuleName: "PACKAGES",
            packages_orders_endpoint: "/api/packages-manager/orders",
            packages_items_endpoint: "/api/packages-manager/items",
            settings_endpoint: "/api/settings",
            products_selling_ranges_endpoint: "/api/packages-manager/products-selling-custom-date-ranges",
            package_discounts_endpoint: "/api/package-discounts",
            wholesaler_pricing_endpoint: "/api/packages-manager/wholesaler-pricing",

            //User data
            user: {},

            //Settings
            settings: [],

            //PackageOrders
            packageOrders: [],
            packageOrdersPagesCount: 0,
            packageOrdersTotal: 0,
            ordersChangesSeenState: {},
            reportSentDates: {},
            groupOrdersRealisationState: {},
            packageOrdersAvailableSearchOptions: [
                {
                    name: "Nazwa zamówienia",
                    ordinal: 0,
                },
                {
                    name: "Nazwa pozycji",
                    ordinal: 1,
                },
                {
                    name: "Numer bloz pozycji",
                    ordinal: 2,
                },
            ],
            //PackagesItems
            packageItems: [],
            packageItemsPagesCount: 0,
            packageItemsTotal: 0,
            packageItemSuppliesTable: "-",
            lastMailReportSendDate: [],
            packageItemsStatuses: {
                ITEM_NOT_RECEIVED: 0,
                ITEM_FULLY_RECEIVED: 1,
                ITEM_RECEIVED_WITH_RIGHT_AMOUNT_AND_ACCEPTABLE_DISCOUNT: 2, //Check as received with notifications
                ITEM_RECEIVED_WITH_RIGHT_AMOUNT_BUT_WRONG_DISCOUNT: 3, // Wrong means too low //Check as not received with notifications
                ITEM_RECEIVED_WITH_ACCEPTABLE_AMOUNT_AND_ACCEPTABLE_DISCOUNT: 4, //Check as received with notifications
                ITEM_RECEIVED_WITH_ACCEPTABLE_AMOUNT_BUT_WRONG_DISCOUNT: 5, // Wrong means too low //Check as not received with notifications
                ITEM_RECEIVED_WITH_NOT_ACCEPTABLE_AMOUNT_AND_ACCEPTABLE_DISCOUNT: 6, //Check as not received with notifications
                ITEM_CHECKED_MANUALLY_WITH_MANUAL_NOTIFICATIONS: 7, //Check as received with notifications
                ITEM_RECEIVED_WITH_TO_LOW_AMOUNT_AND_ACCEPTABLE_DISCOUNT: 8, //Check as not received
                ITEM_RECEIVED_WITH_TO_HIGH_AMOUNT_AND_ACCEPTABLE_DISCOUNT: 9, //Check as received with notifications
                ITEM_IGNORED: 10, //Check as not received
            },

            packageOrderStatusMapWithDescription: {
                created: {
                    key: "CREATED",
                    text: "Utworzone",
                    description: "Zamówienie zostało utworzone i jest w trakcie edycji.",
                    icon: "mdi-pencil-circle",
                    color: "grey"
                },
                published: {
                    key: "PUBLISHED",
                    text: "Opublikowane",
                    description: "Zamówienie zostało opublikowane i jest widoczne dla aptek.",
                    icon: "mdi-eye-circle",
                    color: "blue"
                },
                verified: {
                    key: "VERIFIED",
                    text: "Zweryfikowane",
                    description: "Zamówienie zostało zweryfikowane przez apteki w prospektach.",
                    icon: "mdi-check-circle",
                    color: "teal"
                },
                priced: {
                    key: "PRICED",
                    text: "Wycena",
                    description: "Zamówienie zostało wycenione na podstawie ofert dostawców.",
                    icon: "mdi-currency-usd-circle",
                    color: "gold"
                },
                sent: {
                    key: "SENT",
                    text: "Wysłane",
                    description: "Zamówienie zostało wysłane do dostawców.",
                    icon: "mdi-truck-fast",
                    color: "purple"
                },
                delivered: {
                    key: "DELIVERED",
                    text: "Dostarczone",
                    description: "Zamówienie zostało dostarczone do aptek.",
                    icon: "mdi-package-variant-closed",
                    color: "green"
                },
                cancelled: {
                    key: "CANCELLED",
                    text: "Anulowane",
                    description: "Zamówienie zostało anulowane.",
                    icon: "mdi-cancel",
                    color: "orange"
                }
            },
            // Selling ranges
            sellingCustomDateRanges: [],

            // wholesaller pricing
            packageOrderWholesalerPricing: [],
            packageOrderWholesalerPricingByWholesaler: {},


        }),
        getters: {
            //Common
            getBackendModuleName: (state) => state.backendModuleName,
            //User
            getPackagesManagerSettings: (state) => state.settings,
            //PackageOrders
            getPackageOrders: (state) => state.packageOrders,
            getPackageOrdersPagesCount: (state) => state.packageOrdersPagesCount,
            getPackageOrdersTotal: (state) => state.packageOrdersTotal,
            getOrdersChangesSeenState: (state) => state.ordersChangesSeenState,
            getReportSentDates: (state) => state.reportSentDates,
            getPackageOrdersAvailableSearchOptions: (state) =>
                state.packageOrdersAvailableSearchOptions,
            getPackageItems: (state) => state.packageItems,
            getPackageItemsPagesCount: (state) => state.packageItemsPagesCount,
            getPackageItemsTotal: (state) => state.packageItemsTotal,
            getPackageItemSuppliesTable: (state) => state.packageItemSuppliesTable,
            getLastMailReportSendDate: (state) => state.lastMailReportSendDate,
            getPackageItemsStatuses: (state) => state.packageItemsStatuses,
            getGroupOrdersRealisationState: (state) =>
                state.groupOrdersRealisationState,

            getPackageOrderStatusMapWithDescription: (state) => state.packageOrderStatusMapWithDescription,
            // wholesaler pricing
            getPackageOrderWholesalerPricing: (state) => state.packageOrderWholesalerPricing,
            getPackageOrderWholesalerPricingByWholesaler: (state) => state.packageOrderWholesalerPricingByWholesaler,


        },
        actions: {
            // mutations
            setPackagesManagerUser(user) {
                this.user = user;
            },
            setPackagesManagerSettings(settings) {
                this.settings = settings;
            },
            setPackageOrders(orders) {
                this.packageOrders = orders;
            },
            setPackageOrdersPagesCount(pagesCount) {
                this.packageOrdersPagesCount = pagesCount;
            },
            setPackageOrdersTotal(rowsCount) {
                this.packageOrdersTotal = rowsCount;
            },

            setPackageItemsTotal(rowsCount) {
                this.packageItemsTotal = rowsCount;
            },

            setOrdersChangesSeenState(statuses) {
                this.ordersChangesSeenState = statuses;
            },
            setReportSentDates(sentDates) {
                this.reportSentDates = sentDates;
            },
            setPackageItems(orders) {
                this.packageItems = orders;
            },
            setPackageItemsPagesCount(pagesCount) {
                this.packageItemsPagesCount = pagesCount;
            },
            setPackageItemSuppliesTable(supplies) {
                this.packageItemSuppliesTable = supplies;
            },
            setLastMailReportSendDate(sendDate) {
                this.lastMailReportSendDate = sendDate;
            },
            setGroupOrdersRealisationState(realisation) {
                this.groupOrdersRealisationState = realisation;
            },
            setPackageOrderWholesalerPricing(pricing) {
                this.packageOrderWholesalerPricing = pricing;
            },

            setPackageOrderWholesalerPricingByWholesaler(pricingMap) {
                this.packageOrderWholesalerPricingByWholesaler = pricingMap;
            },

            // actions
            // =================================================== new api for packages ================================================
            httpGetPackageOrdersPaging(payload) {
                var groupGuid = payload.groupGuid;
                var grouped = payload.grouped;
                var pageNumber = payload.currentPage;
                var filterRequestObject = payload.searchAndFilterRequest;
                log.log("httpGetPackageOrdersPaging payload:");
                log.log(payload);

                var endpoint_last_part = "/pages/all?page=";
                if (groupGuid != null && groupGuid != undefined && groupGuid.length > 0) {
                    endpoint_last_part = "/pages/order-group-guid/" + groupGuid + "?page=";
                } else if (grouped == true) {
                    endpoint_last_part = "/pages/grouped?page=";
                }

                var endpoint = this.packages_orders_endpoint + endpoint_last_part + pageNumber;
                if (payload.sortingKey) {
                    endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
                }
                if (payload.sortingDirection) {
                    endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
                }

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: filterRequestObject,
                })
                    .then((response) => {
                        log.log("httpGetPackageOrdersPaging response:");
                        log.log(response);
                        if (response.status === 200) {
                            this.setPackageOrdersPagesCount(response.data.payload.totalPages
                            );
                            this.setPackageOrdersTotal(response.data.payload.totalElements
                            );
                            this.setPackageOrders(response.data.payload.content);
                        } else if (response.status === 203) {
                            log.log(response);
                            Swal.fire("Coś jest nie tak!", response.message, "warning");
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error")
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpRemovePackageOrders(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa usuwanie zamówień...");
                var ordersGuids = payload.ordersGuids;
                log.log("Removing orders: " + ordersGuids);
                var remove_endpoint = "/remove/all/guid";


                var endpoint = this.packages_orders_endpoint + remove_endpoint;

                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: ordersGuids,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpRemovePackageOrders");
                    });
            },

            /**
             * Remove all orders for given order group guids set. The method will remove all single orders for every group guid given in payload.
             * Meaning: group order == set of single orders for all drugstores in the group order
             * @param payload - object: {ordersGroupGuids: Array}
             * @returns {Promise<void>}
             */
            httpRemovePackageOrdersForGroupGuids(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa usuwanie zamówień...");
                var endpoint = this.packages_orders_endpoint + "/remove/all/order-group-guid";
                log.log("Removing orders for group guids: " + endpoint);
                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.ordersGroupGuids,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpRemovePackageOrdersForGroupGuids");
                    });
            },

            httpGetPackageOrdersPagesCount() {
                const endpoint = this.packages_orders_endpoint + "/pages/total";
                return axios
                    .get(endpoint, {
                        headers: requiredHeaders(),
                        data: {},
                    })
                    .then((response) => {
                        log.log(response);
                        if (response.status === 200) {
                            this.setPackageOrdersPagesCount(response.data.payload);
                        } else if (response.status === 203) {
                            Swal.fire("Coś jest nie tak!", response.message, "warning");
                            log.log(response);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error")
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpGetOrderById(payload) {
                const endpoint = this.packages_orders_endpoint + "/id/" + payload.orderId;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                });
            },

            httpGetOrderByGuid(payload) {
                const endpoint = this.packages_orders_endpoint + "/guid/" + payload.orderGuid;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                });
            },

            httpDownloadOrdersFromCentral() {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa pobieranie zamówień...");
                const endpoint = this.packages_orders_endpoint + "/from_central/for_current_drugstore";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpDownloadOrdersFromCentral");
                    });
            },


            httpGetOrderChangesSeenStatus(payload) {
                const endpoint = this.packages_orders_endpoint + "/registry/is_seen/orders";

                log.log("Sending post to  " + endpoint);
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.ordersGuids,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            log.log(response);
                            this.setOrdersChangesSeenState(response.data.payload);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error")
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpResetPackageOrder(payload) {
                var orderGuid = payload.orderGuid;
                var endpoint = this.packages_orders_endpoint + "/reset/guid/" + orderGuid;
                log.log("Resetting order on endpoint: " + endpoint);
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa resetowanie zamówienia...");
                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpResetPackageOrder");
                    });
            },

            httpUploadPackageOrderDataToCentralApp(payload) {
                var endpoint = this.packages_orders_endpoint + "/upload/orders";
                log.log("Uploading order on endpoint: " + endpoint);
                log.log(payload);
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                        this.lazyLoaderModule.setProgressBarMessage("");
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpGetGroupOrdersRealisationState(payload) {
                const endpoint =
                    this.packages_orders_endpoint + "/realisation/groupGuid/orders";

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.ordersGuids,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            log.log(response);
                            this.setGroupOrdersRealisationState(response.data.payload);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error")
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpCheckOrderChangesAsSeen(payload) {
                const endpoint =
                    this.packages_orders_endpoint + "/registry/check_seen/" + payload.orderGuid;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpResetPackageOrder");
                    });
            },

            httpGetReportLastSentDatesForOrders(payload) {
                const endpoint = this.packages_orders_endpoint + "/report/sent_date/orders";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.ordersGuids,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            log.log("Fetching report sent dates for orders: " + payload.ordersIds);
                            log.log(response);
                            this.setReportSentDates(response.data.payload);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error")
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpOpenOrderExcelFile(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa otwieranie pliku...");
                const endpoint =
                    this.packages_orders_endpoint + "/open_excel/" + payload.orderGuid;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpOpenOrderExcelFile");
                    });
            },

            // PackageItems
            httpGetPackageItemsByOrderGuidPaging(payload) {
                var pageNumber = payload.currentPage;
                var orderGuid = payload.filterSettingsObject.orderGuid;
                var endpoint =
                    this.packages_items_endpoint + "/pages/order-group-guid/" + orderGuid + "/all?page=" +pageNumber;

                if (payload.sortingKey) {
                    endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
                }
                if (payload.sortingDirection) {
                    endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
                }

                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        log.log(response);
                        if (response.status === 200) {
                            this.setPackageItemsPagesCount(response.data.payload.totalPages
                            );
                            this.setPackageItemsTotal(response.data.payload.totalElements
                            );
                            this.setPackageItems(response.data.payload.content);
                        }

                        return apiRequestsHelper.handleResponseWithDialogs(response, false);

                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetPackageItemsByOrderGuidPaging")
                    });
            },

            httpCopyExistingOrderToNew(payload) {
                var endpoint = this.packages_orders_endpoint + `/group-order-guid/${payload.orderGroupGuid}/create-copy`;
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        if(response.status === 200){
                            this.lazyLoaderModule.handleQueuedTaskResponse(response,{},payload.onFinishedCallback);
                            return new Promise((resolve) => {
                                resolve(response);
                            })
                        }

                        apiRequestsHelper.handleProgressResponseWithDialogs(response, false);
                        this.lazyLoaderModule.handleQueuedTaskResponse(response,{},payload.onFinishedCallback);
                        return new Promise((resolve) => {
                            resolve(response);
                        })
                    }).catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpAutoBindLocalSuppliers");
                    });

            },

            httpGetAllGeneratorPackageItemsByOrderGroupGuidPaging(payload) {
                var pageNumber = payload.currentPage;
                var orderGroupGuid = payload.orderGroupGuid;
                var endpoint =
                    this.packages_items_endpoint + "/pages/generator/order-group-guid/" + orderGroupGuid + "/all?page=" + pageNumber;
                if (payload.sortingKey) {
                    endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
                }
                if (payload.sortingDirection) {
                    endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
                }

                if(payload.groupViewMode){
                    endpoint = endpoint + "&groupViewMode=" + payload.groupViewMode;
                }

                if(payload.drugstoresInGridView){
                    endpoint = endpoint + "&drugstoreInGridView=" + payload.drugstoresInGridView;
                }

                if(payload.wholesalerPricingView){
                    endpoint = endpoint + "&wholesalerPricingView=" + payload.wholesalerPricingView;
                }


                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data:payload.searchAndFilterRequest,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return new Promise((resolve) => {
                                resolve(response)
                            });
                        }

                        return apiRequestsHelper.handleResponseWithDialogs(response, false);

                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetAllGeneratorPackageItemsByOrderGroupGuidPaging")
                    });
            },

            httpGetSingleItemByItemGroupGuidAndDrugstore(payload) {
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${payload.orderGroupGuid}/item-group-guid/${payload.itemGroupGuid}/drugstore/${payload.drugstoreClientId}`;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return new Promise((resolve) => {
                                resolve(response)
                            })
                        }

                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetSingleItemByItemGroupGuidAndDrugstore")
                    });
            },
            httpGetGroupItemBasicDataByItemGroupGuid(payload) {
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${payload.orderGroupGuid}/item-group-guid/${payload.itemGroupGuid}`;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return new Promise((resolve) => {
                                resolve(response)
                            })
                        }

                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetGroupItemBasicDataByItemGroupGuid")
                    });
            },


            /**
             * Change status for single items in payload.
             * @param payload - object ItemStatusChangeRequest: {itemsGuids: Array - single items guid array in this case, itemStatus: number, isReceived :boolean}
             * @returns {Promise<void>}
             */
            httpMassChangeSingleItemStatus(payload) {
                var endpoint = this.packages_items_endpoint + "/status";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpChangePackageItemStatus")
                    });
            },


            httpChangePackageItemIgnoredStatus(payload) {
                var endpoint = this.packages_items_endpoint + "/ignored";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseSilently(response);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpChangePackageItemIgnoredStatus")
                    });
            },

            /**
             * Add notifications to given single items in payload.
             * @param payload - object: ItemNotificationsChangeRequest: {itemsGuids: Array - single items guid array in this case, notification: string,override:boolean}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpAddNotificationsToSingleItems(payload,showSuccessDialog=true) {
                var endpoint = this.packages_items_endpoint + "/notifications";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpAddNotificationsToSingleItems")
                });
            },

            /**
             * Add notifications to given group items in a group order.
             * Meaning: all items with same itemGroupGuid (contained in payload array) in all drugstores in the order group
             *
             * @param payload - object: {orderGroupGuid: string, ItemNotificationsChangeRequest: {itemsGuids: Array - itemsGroupGuids in this case, notification: string,override:boolean}}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpAddNotificationsToGroupItems(payload,showSuccessDialog=true) {
                // This method is used to add notifications to items in a group order
                const orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/notifications`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.notificationsRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpAddNotificationsToSingleItems")
                });
            },

            httpGetSuppliesForPackageItem(payload) {
                var endpoint =
                    this.packages_items_endpoint + "/supplies/" + payload.blozNumber;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        log.log(response);
                        if (response.status === 200) {
                            this.setPackageItemSuppliesTable(response.data.payload
                            );
                        }
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetSuppliesForPackageItem")
                    });
            },

            httpSendReportForItems(payload) {
                var endpoint = this.packages_items_endpoint + "/report/send";
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Wysyłanie raportu do centrali...");
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpSendReportForItems");
                    });
            },


            httpExportAndSendPackageOrderToDrugstoresInvolved(payload) {
                var endpoint = this.packages_orders_endpoint + "/send_by_email/all/guid";
                var guids = payload.ordersGuids;

                if (payload.ordersGroupGuids) {
                    endpoint = this.packages_orders_endpoint + "/send_by_email/all/order-group-guid";
                    guids = payload.ordersGroupGuids;
                }
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Wysyłanie export i wysyłka zamówień...");
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: guids,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpExportAndSendPackageOrderToDrugstoresInvolved");
                    });
            },

            httpGetLastMailReportSendDate(payload) {
                var endpoint =
                    this.packages_items_endpoint + "/report/last/" + payload.currentOrderId;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        log.log(response);
                        if (response.status === 200) {
                            this.setLastMailReportSendDate(response.data.payload.content);
                        } else if (response.status === 203) {
                            Swal.fire("Coś jest nie tak!", response.message, "warning");
                            log.log(response);
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error")
                        }
                    })
                    .catch((error) => {
                        log.log("Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error")
                    });
            },

            httpRemovePackageItemsForLocalSurplus(payload) {
                var itemsGuids = payload.itemsGuids;
                log.log("Items to remove: " + itemsGuids);
                var endpoint = this.packages_items_endpoint + "/remove/surplus/all/guid";

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: itemsGuids,
                })
                    .then((response) => {
                        return apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpRemovePackageItemsForLocalSurplus");
                    })
            },

            httpUpdateItemsBloz(payload) {
                var endpoint =
                    this.packages_items_endpoint +
                    "/" +
                    payload.itemGuid +
                    "/bloz/" +
                    payload.blozNumber;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpUpdateItemsBloz");
                    })
            },

            httpCheckSuppliesForOrder(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa sprawdzanie dostaw...");
                var endpoint = this.packages_orders_endpoint + "/supplies/check";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpCheckSuppliesForOrder");
                    })
            },
            httpSavePackageOrderFileInLocalFolder(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa import zamówień...");
                var endpoint = this.packages_orders_endpoint + "/save_file";
                return axios({
                    method: "post",
                    url: endpoint,
                    responseType: "blob",
                    headers: {
                        Authorization: authHeader(),
                        'authMethod': 'CUSTOM_JWT',
                        "Content-Type":
                            "multipart/form-data;application/json; application/octet-stream",
                    },
                    data: payload.fileToSend,
                }).then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                    .catch((error) => {
                        apiRequestsHelper.catchResponseError(error, "httpSavePackageOrderFileInLocalFolder");
                    })

            },


            httpSavePackageOrderFile(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                const guid = payload.orderGuid
                const isGroupOrder = payload.isGroupOrder
                this.lazyLoaderModule.setProgressBarMessage("Trwa zapis pliku zamówienia...");
                var endpoint = this.packages_orders_endpoint + "/file/save/guid/" + guid + "/is_group/" + isGroupOrder;
                return axios({
                    method: "post",
                    url: endpoint,
                    responseType: "blob",
                    headers: {
                        Authorization: authHeader(),
                        'authMethod': 'CUSTOM_JWT',
                        "Content-Type":
                            "multipart/form-data;application/json; application/octet-stream",
                    },
                    data: payload.fileToSend,
                });

            },
            httpGetOrderFileKeyMap(payload) {
                const orderToDivide = payload.toDivide
                var endpoint = this.packages_orders_endpoint + "/file-key-map/to_divide/" + orderToDivide;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                });


            },

            httpSharePackageOrderByGuid(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa udostępnianie zamówień...");
                var orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/share";

                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }

                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpSharePackageOrderByGuid");
                    });
            },

            httpAddGroupOrderParsedFromFile(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                this.lazyLoaderModule.setProgressBarMessage("Trwa sprawdzanie dostaw...");
                var endpoint = this.packages_orders_endpoint + "/add/group";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                })

            },
            httpCreateNewGroupOrder(payload) {
                var endpoint = this.packages_orders_endpoint + "/create";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCreateNewGroupOrder")
                });

            },
            httpGetPackageGroupOrderByGuid(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/group-order-guid/" + orderGroupGuid;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPackageGroupOrderByGuid")
                });

            },

            httpGetCurrentGeneratorOrderProductsTablePaging(payload) {
                var pageNumber = payload.currentPage;
                var endpoint = this.packages_items_endpoint + "/order-group-guid/" + payload.orderGroupGuid + "/items?page=" + pageNumber;
                if (payload.sortingKey) {
                    endpoint = endpoint + "&sortingKey=" + payload.sortingKey;

                }
                if (payload.sortingDirection) {
                    endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
                }
                log.log("Sending request:", endpoint, payload);
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.searchAndFilterRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetCurrentGeneratorOrderProductsTablePaging")
                });
            },

            httpGetBoundProductDrugstoresItemsMap(payload) {
                var endpoint = this.packages_items_endpoint + "/product-drugstores-bound/order-group-guid/" + payload.orderGroupGuid;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetBoundProductDrugstoresItemsMap")
                });
            },

            async httpGetItemsBelowLogisticMinPerOrder(payload) {
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${payload.orderGroupGuid}/items-below-logistic-min-per-order`;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetItemsBelowLogisticMinPerOrder")
                });
            },

            httpGetSuppliesLogistics(payload) {
                const centralProductGuid = payload.centralProductGuid
                const drugstoresClientIds = payload.drugstoresClientIds
                const groupViewMode = payload.groupViewMode
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/supplies/product/" + centralProductGuid + `/order-group-guid/${orderGroupGuid}`
                if(groupViewMode){
                    endpoint = endpoint + "?groupViewMode=true";
                }
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: drugstoresClientIds,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetSuppliesLogistics")
                });

            },

            httpGetSellingLogistics(payload) {
                const centralProductGuid = payload.centralProductGuid
                const drugstoresClientIds = payload.drugstoresClientIds
                const groupViewMode = payload.groupViewMode
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/selling/product/" + centralProductGuid;
                endpoint = endpoint + `?groupViewMode=${groupViewMode}&orderGroupGuid=${orderGroupGuid}`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: drugstoresClientIds,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetSellingLogistics")
                });

            },

            httpGetSellingDetails(payload) {
                const centralProductGuid = payload.centralProductGuid
                const drugstoresClientIds = payload.drugstoresClientIds
                const groupViewMode = payload.groupViewMode
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/selling/details/" + centralProductGuid + `/order-group-guid/${orderGroupGuid}`

                if(groupViewMode){
                    endpoint = endpoint + "?groupViewMode=true";
                }
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: drugstoresClientIds,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetSellingDetails")
                });

            },




            httpGetProductLogistics(payload) {
                const centralProductGuid = payload.centralProductGuid
                var endpoint = this.packages_orders_endpoint + "/product/" + centralProductGuid;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetProductLogistics")
                });

            },

            httpGetDrugstoresLogistics(payload) {
                const drugstoresClientIds = payload.drugstoresClientIds
                const groupViewMode = payload.groupViewMode
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + `/drugstores/data/order-group-guid/${orderGroupGuid}`;
                if(groupViewMode){
                    endpoint = endpoint + "?groupViewMode=true";
                }
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: drugstoresClientIds,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetDrugstoresLogistics")
                });

            },

            httpGetRunStockCalcProcedure() {
                var endpoint = this.packages_orders_endpoint + "/stockCalcProcedure";
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if(response.status === 200){
                        this.lazyLoaderModule.handleQueuedTaskResponse(response);
                        return new Promise((resolve) => {
                            resolve(response);
                        })
                    }

                    apiRequestsHelper.handleProgressResponseWithDialogs(response, false);
                    this.lazyLoaderModule.handleQueuedTaskResponse(response);
                    return new Promise((resolve) => {
                        resolve(response);
                    })
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetRunStockCalcProcedure");
                });

            },


            /**
             * Adds products to selected group order. Adds only products thta are not already assigned to order
             * Meaning: group order == a set of orders for different drugstores grouped together by common orderGroupGuid
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpAddProductToGroupOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const productsGuids = payload.centralProductsGuids
                var endpoint = this.packages_orders_endpoint + "/group-order-guid/" + orderGroupGuid + "/products/add";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: productsGuids,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpAddProductToGroupOrder")
                });

            },

            httpGetGroupOrderProductsGuids(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/group-order-guid/" + orderGroupGuid + "/products/guids";
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetGroupOrderProductsGuids")
                });

            },

            httpRemoveProductFromGroupOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const productsGuids = payload.centralProductsGuids
                var endpoint = this.packages_orders_endpoint + "/group-order-guid/" + orderGroupGuid + "/products/remove";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: productsGuids,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpRemoveProductFromGroupOrder")
                });

            },


            /**
             * Updates the name of a group item in an order -> updates the name in all single items in group (by itemGroupGuid)
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpUpdateGroupItemNameInOrder(payload) {
                const {itemGroupGuid, orderGroupGuid, name} = payload;
                var endpoint = `${this.packages_items_endpoint}/item-group-guid/${itemGroupGuid}/order-group-guid/${orderGroupGuid}/name/${encodeURIComponent(name)}`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => resolve(response));
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateGroupItemNameInOrder");
                });
            },

            /**
             * Updates the amount of a single item in an order by itemGroupGuid and drugstoreClientId
             * Meaning: single item == an item for a specific drugstore in a group order
             * Method required in 2d table view of order generator when we only got orderGroupGuid, itemGroupGuid and drugstoreClientId to locate the item.
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpUpdateSingleItemAmountByItemGroupGuidAndDrugstoreClientId(payload) { //
                // the only update wxception where drugstoreClientId is mandatory, because amount is set per drugstore
                const {itemGroupGuid, orderGroupGuid, drugstoreClientId, amount} = payload;
                const endpoint = `${this.packages_items_endpoint}/item-group-guid/${itemGroupGuid}/order-group-guid/${orderGroupGuid}/amount/${amount}/drugstore/${drugstoreClientId}`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => resolve(response));
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateSingleItemAmountByItemGroupGuidAndDrugstoreClientId");
                });
            },

            /**
             * Updates the amount of many single items in an order by their individual guids. The same amount is set to many items.
             * Meaning: single item == an item for a specific drugstore in a group order
             * Single item can be identified by single item guid or by orderGroupGuid + itemGroupGuid + drugstoreClientId.
             * @param payload - ItemAmountChangeRequest object: {itemsGuids:Array, amount:float}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpUpdateAmountInSingleItemsByItemsGuids(payload,showSuccessDialog=true) {
                var endpoint = this.packages_items_endpoint + "/amounts";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateAmountInSingleItemsByItemsGuids")
                });
            },

            /**
             * Updates the amount of many group items in an order by their itemGroupGuids. The same amount is set to all single items in each group of items.
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order,
             * As itemsGuids in payload, we are giving itemGroupGuids here to set an amount to all single items of every group item.
             * @param payload - {orderGroupGuid:str, ItemAmountChangeRequest object: {itemsGuids:Array, amount:float}}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpUpdateAmountInGroupItemsByGroupItemsGuids(payload,showSuccessDialog=true) {
                // This method is used to add notifications to items in a group order
                const orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/amounts`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.amountRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateAmountInGroupItemsByGroupItemsGuids")
                });
            },


            /**
             * Updates the EAN of a group item in an order -> updates the EAN in all single items in group (by itemGroupGuid)
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpUpdateGroupItemEanInOrder(payload) {
                const {itemGroupGuid, orderGroupGuid, ean} = payload;
                var endpoint = `${this.packages_items_endpoint}/item-group-guid/${itemGroupGuid}/order-group-guid/${orderGroupGuid}/ean/${encodeURIComponent(ean)}`;


                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => resolve(response));
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateGroupItemEanInOrder");
                });
            },

            /**
             * Updates the BLOZ of a group item in an order -> updates the BLOZ in all single items in group (by itemGroupGuid)
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpUpdateGroupItemBlozInOrder(payload) {
                const {itemGroupGuid, orderGroupGuid, bloz,drugstoreClientId} = payload;
                var endpoint = `${this.packages_items_endpoint}/item-group-guid/${itemGroupGuid}/order-group-guid/${orderGroupGuid}/bloz/${encodeURIComponent(bloz)}`;
                if (drugstoreClientId) {
                    endpoint += `?drugstoreClientId=${drugstoreClientId}`;
                }

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => resolve(response));
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateGroupItemBlozInOrder");
                });
            },

            /**
             * Updates the offer price of a group item in an order -> updates the offer price in all single items in group (by itemGroupGuid)
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpUpdateGroupItemOfferPriceInOrder(payload) {
                const {itemGroupGuid, orderGroupGuid, offerPrice} = payload;
                var endpoint = `${this.packages_items_endpoint}/item-group-guid/${itemGroupGuid}/order-group-guid/${orderGroupGuid}/offerPrice/${offerPrice}`;
              
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => resolve(response));
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateGroupItemOfferPriceInOrder");
                });
            },


            /**
             * Updates the offer-price of many single items in an order by their individual guids. The same offer-price is set to many items.
             * Meaning: single item == an item for a specific drugstore in a group order
             * Single item can be identified by single item guid or by orderGroupGuid + itemGroupGuid + drugstoreClientId.
             * @param payload - ItemPriceChangeRequest object: {itemsGuids:Array, offer-price:float}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpUpdateOfferPriceInSingleItemsByItemsGuids(payload,showSuccessDialog=true) {
                var endpoint = this.packages_items_endpoint + "/offer-prices";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateOfferPriceInSingleItemsByItemsGuids")
                });
            },

            /**
             * Updates the offer-price of many group items in an order by their itemGroupGuids. The same offer-price is set to all single items in each group of items.
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order,
             * As itemsGuids in payload, we are giving itemGroupGuids here to set an offer-price to all single items of every group item.
             * @param payload -  {orderGroupGuid: string,ItemPriceChangeRequest object: {itemsGuids:Array, offerPrice:float}}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpUpdateOfferPriceInGroupItemsByGroupItemsGuids(payload,showSuccessDialog=true) {
                // This method is used to add notifications to items in a group order
                const orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/offer-prices`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.priceRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateOfferPriceInGroupItemsByGroupItemsGuids")
                });
            },

            /**
             * Updates the offerPrice and offerPriceAfterDiscount field of an item in an order by itemGroupGuid
             * @param payload
             * @param showSuccessDialog
             * @returns {Promise<unknown | undefined | void>}
             */
            httpUpdateOfferPriceCalculatedInGroupItemsByGroupItemsGuids(payload,showSuccessDialog=true) {
                // This method is used to add notifications to items in a group order
                const orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/offer-prices/calculated`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.priceRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateOfferPriceCalculatedInGroupItemsByGroupItemsGuids")
                });
            },


            /**
             * Updates the quoted-price of many single items in an order by their individual guids. The same quoted-price is set to many items.
             * Meaning: single item == an item for a specific drugstore in a group order
             * Single item can be identified by single item guid or by orderGroupGuid + itemGroupGuid + drugstoreClientId.
             * @param payload - ItemPriceChangeRequest object: {itemsGuids:Array,price:float}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpUpdateQuotedPriceInSingleItemsByItemsGuids(payload,showSuccessDialog=true) {
                var endpoint = this.packages_items_endpoint + "/quoted-prices";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateQuotedPriceInSingleItemsByItemsGuids")
                });
            },

            /**
             * Updates the quoted-price of many group items in an order by their itemGroupGuids. The same quoted-price is set to all single items in each group of items.
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order,
             * As itemsGuids in payload, we are giving itemGroupGuids here to set an quoted-price to all single items of every group item.
             * @param payload -  {orderGroupGuid: string,ItemPriceChangeRequest object: {itemsGuids:Array, price:float}}
             * @param showSuccessDialog
             * @returns {Promise<unknown | void>}
             */
            httpUpdateQuotedPriceInGroupItemsByGroupItemsGuids(payload,showSuccessDialog=true) {
                // This method is used to add notifications to items in a group order
                const orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/quoted-prices`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.priceRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateQuotedPriceInGroupItemsByGroupItemsGuids")
                });
            },

            httpUpdateDiscountCalculatedInGroupItemsByGroupItemsGiuds(payload,showSuccessDialog=true) {
                // This method is used to add notifications to items in a group order
                const orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/discounts/calculated`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.discountRequest,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateDiscountCalculatedInGroupItemsByGroupItemsGiuds")
                });
            },



            httpRemoveItemsFromGroupOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const itemsGroupGuids = payload.itemsGroupGuids
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/items/remove";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: itemsGroupGuids,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpRemoveItemsFromGroupOrder")
                });

            },

            httpGetOrderGeneratorAvailableFilters(params) {
                const orderGroupGuid = params.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + `/generator/available-filters/order-group-guid/${orderGroupGuid}`;
                if (params && Object.keys(params).length > 0) {
                    const paramsWithoutOrderGroupGuid = Object.fromEntries(Object.entries(params).filter(([key]) => key !== "orderGroupGuid"));
                    const query = new URLSearchParams(paramsWithoutOrderGroupGuid).toString();
                    endpoint = endpoint + "?" + query;
                }

                return axios({
                    method: "get",
                    url: endpoint,
                    headers: {
                        Authorization: authHeader(),
                        'authMethod': 'CUSTOM_JWT'
                    },
                    data: {},
                })
            },

            /**
             * Updates basic data of a group order.
             * Meaning: group order == a set of orders for different drugstores grouped together by common orderGroupGuid
             * @param payload
             * @returns {Promise<unknown | void>}
             */
            httpUpdateGroupOrderBasicData(payload) {
                const orderGroupGuid = payload.groupGuid
                console.log("Saving order data for group guid: " + orderGroupGuid);
                var endpoint = this.packages_orders_endpoint + "/update/order-group-guid/" + orderGroupGuid;
                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateGroupOrderBasicData")
                });
            },

            /**
             * Updates the ignored status of all group items in an order -> updates the ignored status in all single items in group (by itemGroupGuid)
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order
             * @param payload - object: {orderGroupGuid:string, ItemIgnoredChangeRequest:{itemsGuids:Array, ignored:boolean}}
             * @returns {Promise<unknown | void>}
             */
            httpUpdateAllGroupItemsIgnoredInOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_items_endpoint + `/order-group-guid/${orderGroupGuid}/ignored`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.ignoredChangeRequest,
                }).then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateAllGroupItemsIgnoredInOrder")
                });
            },

            /**
             * Adds drugstores to selected group order -> single package order will be added for every drugstoreClientId given in payload.
             * Meaning: group order == a set of orders for different drugstores grouped together by common orderGroupGuid
             * @param payload - object: {orderGroupGuid:string, drugstoresClientIds:Array}
             * @returns {Promise<unknown | void>}
             */
            httpAddDrugstoreToGroupOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const drugstoresClientIds = payload.drugstoresClientIds
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/drugstores/add";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: drugstoresClientIds,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpAddDrugstoreToGroupOrder")
                });

            },

            /**
             * Removes drugstores from selected group order -> single package order will be removed for every drugstoreClientId given in payload.
             * Meaning: group order == a set of orders for different drugstores grouped together by common orderGroupGuid
             * @param payload - object: {orderGroupGuid:string, drugstoresClientIds:Array}
             * @returns {Promise<unknown | void>}
             */
            httpRemoveDrugstoreFromGroupOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const drugstoresClientIds = payload.drugstoresClientIds
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/drugstores/remove";
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: drugstoresClientIds,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpRemoveDrugstoreFromGroupOrder")
                });

            },

            /**
             * Calculates amount for group items in order -> updates the amount in all single items in group (by itemGroupGuid)
             * Meaning: group item == a set of items (single items) that are the same product for different drugstores in group order
             * @param payload - object: {orderGroupGuid:string, itemsGroupGuids:Array, calculationMode:string, valueKey:string - type of calculation source}
             * @returns {Promise<unknown | void>}
             */
            httpCalculateAmountForGroupItemsInOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const itemsGroupGuids = payload.itemsGroupGuids
                const calculationMode = payload.calculationMode
                var endpoint = this.packages_orders_endpoint + `/order-group-guid/${orderGroupGuid}/amount/key/${payload.valueKey}/calcMode/${calculationMode}`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: itemsGroupGuids,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCalculateAmountForGroupItemsInOrder")
                });

            },
            /**
             * Calculates amount for all group items in order -> updates the amount in all single items in all groups (by itemGroupGuid)
             * @param payload - object: {orderGroupGuid:string, calculationMode:string, valueKey:string - type of calculation source}
             * @returns {Promise<unknown | void>}
             */
            httpCalculateAmountForAllGroupItemsInOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const calculationMode = payload.calculationMode
                var endpoint = this.packages_orders_endpoint + `/order-group-guid/${orderGroupGuid}/amount/key/${payload.valueKey}/calcMode/${calculationMode}/all`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCalculateAmountForGroupItemsInOrder")
                });

            },

            /**
             * Calculates amount for single items in order -> updates the amount in single items only (by itemGuid)
             * Meaning: single item == an item for a specific drugstore in a group order
             * @param payload - object: {orderGroupGuid:string, itemsGuids:Array, calculationMode:string, valueKey:string - type of calculation source}
             * @returns {Promise<unknown | void>}
             */
            httpCalculateAmountForSingleItemsInOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const itemsGuids = payload.itemsGuids
                const calculationMode = payload.calculationMode
                var endpoint = this.packages_orders_endpoint + `/order-group-guid/${orderGroupGuid}/items/amount/key/${payload.valueKey}/calcMode/${calculationMode}`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: itemsGuids,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCalculateAmountForSingleItemsInOrder")
                });

            },

            httpCalculateAmountForAllSingleItemsInOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                const calculationMode = payload.calculationMode
                var endpoint = this.packages_orders_endpoint + `/order-group-guid/${orderGroupGuid}/items/amount/key/${payload.valueKey}/calcMode/${calculationMode}/all`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpCalculateAmountForSingleItemsInOrder")
                });

            },


            httpGetDrugstoresForGroupOrder(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/drugstores";
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetDrugstoresForGroupOrder")
                });


            },

            httpSendEmailWithWithGroupOrderData(payload) {
                var mailMessage = payload.mailMessage;
                var orderGroupGuid = payload.orderGroupGuid;
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/send/email";
                log.log("mailMessage", mailMessage)
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: mailMessage,
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSendEmailWithWithGroupOrderData")
                });

            },

            httpExportGroupOrderToFile(payload) {
                var outputFileFormat = payload.outputFileFormat;
                var orderGroupGuid = payload.orderGroupGuid;
                var flatExport = payload.flatExport;

                var endpoint = this.packages_orders_endpoint + "/export/order-group-guid/" + orderGroupGuid;

                const fileFormat = outputFileFormat != null ? outputFileFormat : "XLS";
                const flat = flatExport != null ? flatExport : true;
                endpoint = endpoint + "?outputFileFormat=" + fileFormat + "&flatExport=" + flat;

                console.log("Exporting group order with endpoint: " + endpoint);

                if (fileFormat === "XLSX" || fileFormat === "XLS") {
                    return axios({
                        method: "post",
                        url: endpoint,
                        headers: requiredHeaders(),
                        data: {},
                        responseType: 'blob' // required for binary data and files types
                    });
                } else {
                    return axios({
                        method: "post",
                        url: endpoint,
                        headers: requiredHeaders(),
                        data: {},
                    });
                }


            },


            httpGetGroupOrderEMailHistory(payload) {
                const orderGroupGuid = payload.orderGroupGuid
                var endpoint = this.packages_orders_endpoint + "/order-group-guid/" + orderGroupGuid + "/email/history";
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetGroupOrderEMailHistory")
                });


            },

            httpGetLastStockDates(payload) {
                const drugstoreClientId = payload.drugstoreClientId
                var endpoint = this.packages_orders_endpoint + "/stock/dates/drugstore/" + drugstoreClientId;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetLastStockDates")
                });


            },


            //Settings
            httpGetPackagesManagerSettings() {
                var endpoint = this.settings_endpoint + "/module/" + this.backendModuleName;
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        if (response.status === 200) {
                            log.log("Displaying settings payload:");
                            log.log(response.data.payload);
                            this.setPackagesManagerSettings(response.data.payload);
                        } else if (response.status === 203) {
                            log.log(response);
                            Swal.fire("Coś jest nie tak!", response.message, "warning");
                        } else {
                            var errorMessage = "";
                            if (response.data.message) {
                                errorMessage = response.data.message;
                            }
                            log.log("Wystąpił błąd!: " + errorMessage);
                            Swal.fire("Wystąpił błąd!", errorMessage, "error");
                        }
                    })
                    .catch((error) => {
                        log.log("Catch: Wystąpił błąd!: " + error);
                        Swal.fire("Wystąpił błąd!", error + "", "error");
                    });
            },

            // Selling custom date ranges for products
            httpGetSellingCustomDateRanges(payload) {
                const groupGuid = payload.packageOrderGroupGuid;
                const endpoint = `${this.products_selling_ranges_endpoint}/order-group-guid/${groupGuid}`;

                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        if (response.status === 200) {
                            // Sortowanie po listIndex dla pewności
                            let ranges = response.data.payload || [];
                            ranges.sort((a, b) => a.listIndex - b.listIndex);
                            this.sellingCustomDateRanges = ranges;
                            return new Promise((resolve) => {
                                resolve(ranges)
                            })
                        }
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetSellingCustomDateRanges");
                    });
            },

            httpCreateSellingCustomDateRange(payload) {
                const groupGuid = payload.packageOrderGroupGuid;
                const endpoint = `${this.products_selling_ranges_endpoint}/order-group-guid/${groupGuid}`;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.dto,
                })
                    .then((response) => {
                        if( response.status === 200) {
                            return new Promise((resolve) => {
                                resolve(response)
                            })
                        }
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);

                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpCreateSellingCustomDateRange");
                    });
            },

            httpUpdateSellingCustomDateRange(payload) {
                const rangeGuid = payload.rangeGuid;
                console.log("Updating selling custom date range with GUID: " + rangeGuid);
                const endpoint = `${this.products_selling_ranges_endpoint}/guid/${rangeGuid}`;

                // Lazy loader opcjonalny przy małych update'ach inline, tutaj wyłączony dla płynności UI
                // chyba że chcesz blokować ekran przy każdej zmianie daty.
                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.dto,
                })
                    .then((response) => {
                        if( response.status === 200) {
                            return new Promise((resolve) => {
                                resolve(response)
                            })
                        }
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpUpdateSellingCustomDateRange");
                    });
            },

            httpDeleteSellingCustomDateRange(payload) {
                const rangeGuid = payload.rangeGuid;
                const endpoint = `${this.products_selling_ranges_endpoint}/guid/${rangeGuid}`;

                return axios({
                    method: "delete",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        if( response.status === 200) {
                            apiRequestsHelper.handleResponseWithDialogs(response, true);
                            return new Promise((resolve) => {
                                resolve(response)
                            })
                        }
                        return apiRequestsHelper.handleResponseWithDialogs(response, true);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpDeleteSellingCustomDateRange");
                    });
            },

            // Metoda pomocnicza do czyszczenia stanu przy zamknięciu modala
            clearSellingCustomDateRanges() {
                this.sellingCustomDateRanges = [];
            },



            /**
             * Pobiera listę rabatów pakietowych dla danej grupy zamówień.
             */
            httpGetPackageDiscountsPaging(payload) {
                const {
                    orderGroupGuid,
                    page,
                    sortingKey,
                    sortingDirection,
                    wholesalerGuid = null,
                    includeAll = false,
                } = payload;

                let endpoint = `${this.package_discounts_endpoint}/paging/all?orderGroupGuid=${encodeURIComponent(orderGroupGuid)}&page=${page ?? 0}`;

                if (wholesalerGuid) {
                    endpoint += `&wholesalerGuid=${encodeURIComponent(wholesalerGuid)}`;
                }

                if (includeAll === true) {
                    endpoint += `&includeAll=true`;
                }

                if (sortingKey) endpoint += `&sortingKey=${encodeURIComponent(sortingKey)}`;
                if (sortingDirection) endpoint += `&sortingDirection=${encodeURIComponent(sortingDirection)}`;


                this.lazyLoaderModule.setDisplayLazyLoader(true);
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return response.data; // Zwracamy payload z paginacją
                        }
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetPackageDiscountsPaging");
                    })
                    .finally(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                    });
            },

            /**
             * Gets all discounts for given order group.
             * @param payload
             * @returns {Promise<axios.AxiosResponse<any> | void>}
             */
            httpGetPackageDiscounts(payload) {
                const {
                    orderGroupGuid,
                    wholesalerGuid = null,
                    includeAll = false,
                } = payload;

                let endpoint = `${this.package_discounts_endpoint}/all?orderGroupGuid=${encodeURIComponent(orderGroupGuid)}`;

                if (wholesalerGuid) {
                    endpoint += `&wholesalerGuid=${encodeURIComponent(wholesalerGuid)}`;
                }

                if (includeAll === true) {
                    endpoint += `&includeAll=true`;
                }
                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        if (response.status === 200) {
                           return new Promise((resolve) => {
                               let discounts = response.data.payload || [];
                               resolve(discounts)
                           })
                        }
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetPackageDiscounts");
                    })

            },

            httpGetPackageDiscountsByWholesalerGuids(payload) {
                console.log("httpGetPackageDiscountsByWholesalerGuids",payload);
                const orderGroupGuid = payload.orderGroupGuid;
                const endpoint = this.package_discounts_endpoint + `/all/wholesaler-guids?orderGroupGuid=${encodeURIComponent(orderGroupGuid)}`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: {
                        Authorization: authHeader(),
                    },
                    data: payload.guids,
                }).then((response) => {
                    if(response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        })
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPackageDiscountsByWholesalerGuids");
                });
            },

            /**
             * Tworzy nowy rabat pakietowy.
             */
            httpCreatePackageDiscount(payload) {
                const endpoint = this.package_discounts_endpoint;

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload.dto, // CreatePackageDiscountRequest
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                        return response;
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpCreatePackageDiscount");
                    })

            },

            /**
             * Aktualizuje metadane rabatu pakietowego.
             */
            httpUpdatePackageDiscount(payload) {
                const { guid, dto } = payload;
                const endpoint = `${this.package_discounts_endpoint}/${guid}`;
                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: dto, // UpdatePackageDiscountRequest
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                        return response;
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpUpdatePackageDiscount");
                    })

            },

            /**
             * Usuwa rabat pakietowy.
             */
            httpDeletePackageDiscount(payload) {
                const { guid } = payload;
                const endpoint = `${this.package_discounts_endpoint}/${guid}`;
                return axios({
                    method: "delete",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, true);
                        return response;
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpDeletePackageDiscount");
                    })

            },

// --- PACKAGE DISCOUNT VALUES (WARTOŚCI RABATÓW) ---

            /**
             * Pobiera listę wartości dla rabatów w grupie zamówień.
             */
            httpGetPackageDiscountValues(payload) {
                const {
                    orderGroupGuid,
                    wholesalerGuid = null,
                    includeAll = false,
                } = payload;

                let endpoint = `${this.package_discounts_endpoint}/values?orderGroupGuid=${encodeURIComponent(orderGroupGuid)}`;

                if (wholesalerGuid) {
                    endpoint += `&wholesalerGuid=${encodeURIComponent(wholesalerGuid)}`;
                }

                if (includeAll === true) {
                    endpoint += `&includeAll=true`;
                }


                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return response.data;
                        }
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpGetPackageDiscountValues");
                    });
            },

            /**
             * Aktualizuje konkretną wartość rabatu.
             */
            httpUpdatePackageDiscountValue(payload) {
                const { discountGuid, refGuid, value } = payload;
                const endpoint = `${this.package_discounts_endpoint}/${discountGuid}/values/${refGuid}`;
                // this.lazyLoaderModule.setDisplayLazyLoader(true);

                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: { value: value }, // UpdatePackageDiscountValueRequest
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                        return response;
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpUpdatePackageDiscountValue");
                    })
                    .finally(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                    });
            },

            /**
             * Aktualizuje min logistyczne per apteka.
             */
            httpUpdateLogisticMinPerDrugstoreValue(payload) {
                const { itemGroupGuid,orderGroupGuid, value } = payload;
                const endpoint = `${this.packages_items_endpoint}/order-group-guid/${orderGroupGuid}/item-group-guid/${itemGroupGuid}/logistic-min-per-drugstore`;
                // this.lazyLoaderModule.setDisplayLazyLoader(true);

                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: { value: value }, // UpdatePackageDiscountValueRequest
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                        return response;
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpUpdateLogisticMinPerDrugstoreValue");
                    })
                    .finally(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                    });
            },

            /**
             * Aktualizuje min logistyczne per zamówienie.
             */
            httpUpdateLogisticMinPerOrderValue(payload) {
                const { itemGroupGuid,orderGroupGuid, value } = payload;
                const endpoint = `${this.packages_items_endpoint}/order-group-guid/${orderGroupGuid}/item-group-guid/${itemGroupGuid}/logistic-min-per-order`;
                // this.lazyLoaderModule.setDisplayLazyLoader(true);

                return axios({
                    method: "put",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: { value: value }, // UpdatePackageDiscountValueRequest
                })
                    .then((response) => {
                        apiRequestsHelper.handleResponseWithDialogs(response, false);
                        return response;
                    })
                    .catch((error) => {
                        return apiRequestsHelper.catchResponseError(error, "httpUpdateLogisticMinPerOrderValue");
                    })
                    .finally(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                    });
            },





// =============================== ORDER VIEW LOCK (SIMPLE MODE: NO READ/WRITE DISTINCTION) =============

            buildPackageOrderLockKey(orderGroupGuid) {
                return "PACKAGE_GROUP_ORDER:" + orderGroupGuid;
            },

            acquirePackageOrderViewLock(payload) {
                const { orderGroupGuid } = payload;
                const lockKey = this.buildPackageOrderLockKey(orderGroupGuid);
                return this.commonModule.httpAcquireAppProcessLock({
                    lockKey: lockKey,
                    scope: "VIEW",
                    ttlSeconds: 120,
                    payloadJson: JSON.stringify({ type: "PACKAGE_GROUP_ORDER", orderGroupGuid: orderGroupGuid })
                });
            },

            renewPackageOrderViewLock(payload) {
                const { orderGroupGuid } = payload;
                const lockKey = this.buildPackageOrderLockKey(orderGroupGuid);
                return this.commonModule.httpRenewAppProcessLock({
                    lockKey: lockKey,
                    ttlSeconds: 120,
                    payloadJson: JSON.stringify({ type: "PACKAGE_GROUP_ORDER", orderGroupGuid: orderGroupGuid })
                });
            },

            releasePackageOrderViewLock(payload) {
                const { orderGroupGuid } = payload;
                const lockKey = this.buildPackageOrderLockKey(orderGroupGuid);
                return this.commonModule.httpReleaseAppProcessLock({ lockKey });
            },


            httpPublishProspect(payload) {
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                const groupOrder = payload.groupOrder
                var endpoint = this.packages_orders_endpoint + `/prospects/group-order-guid/${groupOrder.groupGuid}/publish`;
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: groupOrder,
                }).then((response) => {
                    return apiRequestsHelper.handleResponseWithDialogs(response, true);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpPublishProspect")
                }).finally(() => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                })

            },
            // =========== PRICING MODULE MOCK METHODS ===========

            /**
             * [MOCK] Pobiera dostępnych hurtowników do porównania cen.
             * Returns array of {key, name} objects.
             */
            mockGetAvailableWholesalers(payload) {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve([
                            { key: 'PHARMAX', name: 'Pharmax Polska' },
                            { key: 'NEUCA', name: 'Neuca S.A.' },
                            { key: 'FARMACOL', name: 'Farmacol S.A.' },
                            { key: 'PROSPER', name: 'Prosper' },
                            { key: 'PGF', name: 'PGF Urtica' },
                        ]);
                    }, 100);
                });
            },

            /**
             * [MOCK] Importuje wycenę hurtowni z ofert systemowych (Kamsoft).
             */
            mockImportWholesalerPricingFromOffers(payload) {
                const { orderGroupGuid, wholesalerKey } = payload;
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                        resolve({ success: true, wholesalerKey });
                    }, 800);
                });
            },




            /**
             * [MOCK] Eksportuje porównanie wycen do pliku Excel.
             */
            mockExportPricingToExcel(payload) {
                const { orderGroupGuid } = payload;
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                        resolve({ success: true });
                    }, 700);
                });
            },

            /**
             * [MOCK] Wysyła zamówienie do wybranej hurtowni w celu realizacji.
             */
            mockSendPricingOrderToRealisation(payload) {
                const { orderGroupGuid, wholesalerKey } = payload;
                this.lazyLoaderModule.setDisplayLazyLoader(true);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        this.lazyLoaderModule.setDisplayLazyLoader(false);
                        resolve({ success: true });
                    }, 500);
                });
            },

            /**
             * [MOCK] Pobiera dane email dla wybranej hurtowni (do wysyłki zamówienia).
             * Returns {mailTo, mailCc, mailSubject, mailMessage, mailAttachmentName}
             */
            mockGetWholesalerEmailData(payload) {
                const { orderGroupGuid, wholesalerKey } = payload;
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve({
                            mailTo: 'zamowienia@' + (wholesalerKey || 'hurtownia').toLowerCase() + '.pl',
                            mailCc: '',
                            mailSubject: 'Zamówienie do realizacji - ' + (wholesalerKey || ''),
                            mailMessage: 'Uprzejmie przesyłamy zamówienie do realizacji.',
                            mailAttachmentName: 'zamowienie_' + (wholesalerKey || 'hurtownia') + '.xlsx',
                            sendMailDialogTitle: 'Wyślij zamówienie do hurtowni ' + (wholesalerKey || ''),
                        });
                    }, 100);
                });
            },

            /**
             * Adds wholesaler pricing set for whole group order.
             * Backend creates pricing rows for all unique itemGroupGuids in given orderGroupGuid.
             * payload: { orderGroupGuid: string, wholesalerGuid: string }
             */
            httpAddWholesalerPricingSet(payload, showSuccessDialog = true) {
                const endpoint = this.wholesaler_pricing_endpoint + "/add";

                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response);
                        });
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpAddWholesalerPricingSet");
                });
            },

            /**
             * Removes wholesaler pricing set for whole group order.
             * payload: { orderGroupGuid: string, wholesalerGuid: string }
             */
            httpDeleteWholesalerPricingSet(payload, showSuccessDialog = true) {
                const endpoint = this.wholesaler_pricing_endpoint + "/delete";

                return axios({
                    method: "delete",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response);
                        });
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpDeleteWholesalerPricingSet");
                });
            },

            /**
             * Updates single pricing cell: offer price.
             * payload: {
             *   orderGroupGuid: string,
             *   itemGroupGuid: string,
             *   wholesalerGuid: string,
             *   offerPrice: number
             * }
             */
            httpUpdateWholesalerPricingOfferPrice(payload, showSuccessDialog = false) {
                const endpoint = this.wholesaler_pricing_endpoint + "/offer-price";

                return axios({
                    method: "patch",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: payload,
                }).then((response) => {
                    if (response.status === 200) {
                        apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);
                        return new Promise((resolve) => {
                            resolve(response);
                        });
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, showSuccessDialog);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateWholesalerPricingOfferPrice");
                });
            },

            /**
             * Gets all wholesaler pricing rows for whole order group.
             * payload: { orderGroupGuid: string }
             */
            httpGetWholesalerPricingByOrderGroupGuid(payload, saveInStore = true) {
                const orderGroupGuid = payload.orderGroupGuid;
                const endpoint = this.wholesaler_pricing_endpoint + `/order-group-guid/${orderGroupGuid}/all`;

                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        const pricing = response?.data?.payload ?? [];
                        if (saveInStore) {
                            this.setPackageOrderWholesalerPricing(pricing);
                        }
                        return new Promise((resolve) => {
                            resolve(response);
                        });
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetWholesalerPricingByOrderGroupGuid");
                });
            },

            /**
             * Gets wholesaler pricing rows for whole order group and one wholesaler.
             * payload: { orderGroupGuid: string, wholesalerGuid: string }
             */
            httpGetWholesalerPricingByOrderGroupGuidAndWholesalerGuid(payload, saveInStore = false) {
                const orderGroupGuid = payload.orderGroupGuid;
                const wholesalerGuid = payload.wholesalerGuid;
                const endpoint = this.wholesaler_pricing_endpoint + `/order-group-guid/${orderGroupGuid}/wholesaler/${wholesalerGuid}/all`;

                return axios({
                    method: "get",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                }).then((response) => {
                    if (response.status === 200) {
                        const pricing = response?.data?.payload ?? [];

                        if (saveInStore) {
                            this.packageOrderWholesalerPricingByWholesaler = {
                                ...this.packageOrderWholesalerPricingByWholesaler,
                                [wholesalerGuid]: pricing
                            };
                        }

                        return new Promise((resolve) => {
                            resolve(response);
                        });
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);

                }).catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetWholesalerPricingByOrderGroupGuidAndWholesalerGuid");
                });
            },
            buildWholesalerPricingMap(pricingRows = []) {
                const result = {};

                pricingRows.forEach((row) => {
                    const wholesalerGuid = row.wholesalerGuid;
                    const itemGroupGuid = row.itemGroupGuid;

                    if (!result[wholesalerGuid]) {
                        result[wholesalerGuid] = {};
                    }

                    result[wholesalerGuid][itemGroupGuid] = row;
                });

                return result;
            },


        }

    }
);
